import React from 'react';
import PropTypes from 'prop-types';
import css from './NewsTitle.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';
import { generateUniqueId } from '../../../../common/utils/utils';

const NewsTitle = ({ getHandlers, val, gridStyles, name, link, align }) => {
    const { stylers, classes, existCl, existSt } = generateGridStyles(gridStyles, name);
    if (val === null) return <p>-</p>;
    return (
        <div
            key={generateUniqueId()}
            className={
                existCl('wrapper') ||
                (align === 'left'
                    ? classnames(css.flexColumn, css.alignItemsStart)
                    : align === 'right'
                    ? classnames(css.flexColumn, css.alignItemsEnd)
                    : classnames(css.flexColumn, css.alignItemsCenter))
            }
        >
            {val.categories && (
                <div
                    {...getHandlers(false)}
                    style={
                        existSt('icoWrap1') || {
                            padding: '4px 6px',
                            display: 'flex'
                        }
                    }
                    className={existCl('icoWrap1') || classnames(!!link && css.formCursorPointer, css.userNameBlock)}
                >
                    <p
                        className={classes.textWrap}
                        style={{ whiteSpace: 'nowrap', ...stylers.textWrap }}
                        key={`id-${Date.now().toString()}${Math.random()}${Math.random()}`}
                    >{`${val.categories.join(', ') || val}`}</p>
                </div>
            )}
            <p className={classnames(classes.fio, css.buyerName)} style={{ marginTop: val?.categories ? '0px' : '0' }}>
                <p> {val.title ? val.title : '-'} </p>
            </p>
        </div>
    );
};
NewsTitle.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    styles: PropTypes.object,
    name: PropTypes.string
};
export default NewsTitle;
